"use client";
import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { CHAT_ROUTE } from "../zustand/const";
import ChatEngine from "./ChatEngine";
import { chatState } from "../zustand";


function Chat() {
    const { id } = useParams();
    const setRoomId = chatState((state) => state.setRoomId);
    const { pathname } = useLocation();

    useEffect(() => {
        if (id) {
            setRoomId(id)
        }
    }, [id]);

    return (
        <>
            <div className="chat-box" style={{ position: "relative" }}>
                <ChatEngine
                    mode={pathname === CHAT_ROUTE ? 'simple' : 'full'}
                />
            </div>
        </>
    );
}

export default Chat;